import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import {
  dummyimage,
  resort_act,
  resort_inact,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { toast } from "react-toastify";
import DateRange1 from "../../components/DateRange/DateRange1";
import { checkPermission } from "../redux/api/PermissionManager";

// debounce hook (keeps it dependency-free)
function useDebounce(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debounced;
}

const Properties_block = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");

  // States
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [owners, setOwners] = useState([]);
  const [isOwners, setIsOwners] = useState([]);
  const [popup, setPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [activeStates, setActiveStates] = useState([]);
  const [type, setIsType] = useState(null);
  const [isBlockDate, setIsBlockDate] = useState([]);

  const [locationList, setLocationsList] = useState({ states: [], cities: [] });
  const [optionsList, setOptionsList] = useState({ state: null, city: null });
  const [selectedFilter, setSelectedFilter] = useState({
    from_date: new Date().toISOString().split("T")[0],
    to_date: "",
    city: "",
    state: "",
    search: paginationData?.[path]?.search ?? "",
  });
  const debouncedSearch = useDebounce(selectedFilter.search, 350);

  // Handlers
  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
    setPage(1);
  };

  const handleStateSelect = (selected) => {
    setOptionsList({ state: selected, city: null });
    handleChangeFilter("state", selected?.value || "");
    setLocationsList((prev) => ({ ...prev, cities: [] }));
    if (selected?.value) getLocationsList(3, selected.value);
  };

  const handleCitySelect = (selected) => {
    setOptionsList((prev) => ({ ...prev, city: selected }));
    handleChangeFilter("city", selected?.value || "");
  };

  const openPopup = ({ row, type }) => {
    setPopup(true);
    setSelectedRow(row);
    setActiveStates((row?.blocked_duration || []).map(() => true));
    setIsType(type);
  };
  const getBlockDate = async () => {
    try {
      const res = await get(URLS.PROPERTIES_DATE_BLOCK_ROOMS);
      if (res?.status === "success") {
        setIsBlockDate(res?.blocked_dates);
      }
    } catch (error) {
      console.error("Error fetching block dates:", error);
      setIsBlockDate([]);
    }
  };

  useEffect(() => {
    getBlockDate();
  }, []);
  const handleUnblock = () => {
    const filteredDurations = (selectedRow?.blocked_duration || []).filter(
      (_, idx) => activeStates[idx]
    );

    console.log(
      "Filtered blocked_duration values:",
      filteredDurations,
      selectedRow?.property_id
    );

    let value = {
      property_id: selectedRow?.property_id,
      dates: filteredDurations,
    };

    put(URLS.PROPERTIES_UNBLOCK_METHOD, value)
      .then((res) => {
        console.log("res<<____>>", res);
        if (res?.status === "success") {
          toast.success(res?.message || "Room Blocked successful");
          getList(page);
          setPopup(false);
        } else {
          toast.error(res?.error);
        }
      })
      .catch((err) => {
        toast.error("Server error. Please try again.");
        console.error("Room Blocked Error:", err);
      });
  };

  const toggleActive = (idx) =>
    setActiveStates((arr) => arr.map((a, i) => (i === idx ? !a : a)));

  // APIs
  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION}?type=${type}${
      parent_id ? `&parent_id=${parent_id}` : ""
    }`;
    const res = await get(url);
    if (res?.status === "success") {
      const modifiedList = res.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      if (type === 2)
        setLocationsList((prev) => ({ ...prev, states: modifiedList }));
      else if (type === 3)
        setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  const getList = async (pageNumber = 1) => {
    let req = {
      ...selectedFilter,
      search: debouncedSearch,
    };
    if (selectedFilter?.from_date) {
      req.date = new Date(selectedFilter?.from_date)?.toLocaleDateString(
        "en-CA"
      );
    }
    const res = await post(
      `${URLS.PROPERTIES_BLOCK_LIST}?page=${pageNumber}`,
      req
    );
    console.log("LISTTT", res);
    if (res?.status === "success") {
      setPagination({ current_page: pageNumber, last_page: res?.total_pages });
      setOwners(res?.data || []);
      setIsOwners(res);
    }
  };

  // Effects
  useEffect(() => {
    getLocationsList(2);
  }, []);

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page, search: selectedFilter.search },
    }));
  }, [
    selectedFilter.state,
    selectedFilter.city,
    debouncedSearch,
    page,
    selectedFilter.from_date,
    selectedFilter.to_date,
  ]);

  // Table columns
  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ row }) => (
          <p className="red">{row.index + 1 + (page - 1) * 10}</p>
        ),
      },
      {
        Header: "Property",
        accessor: "property_name",
        Cell: ({ value, row }) => (
          <>
            <p
              className="text-nowrap"
              style={{ color: "#AE55F5", fontWeight: "600", width: 50 }}
            >
              {value}
            </p>
            <p style={{ color: "#AE55F5", fontWeight: "600", width: 50 }}>
              {row.original?.property_code}
            </p>
          </>
        ),
      },
      {
        Header: "Hotel Categories",
        accessor: "hotel_category",
        Cell: ({ value }) => (
          <p
            style={{
              color: "#3A3A49",
              fontWeight: "600",
              width: 50,
              paddingLeft: 40,
            }}
          >
            {value}
          </p>
        ),
      },
      {
        Header: "State",
        accessor: "state",
        Cell: ({ value }) => (
          <p style={{ color: "#3A3A49", fontWeight: "600", width: 50 }}>
            {value}
          </p>
        ),
      },
      {
        Header: "City",
        accessor: "city",
        Cell: ({ value }) => (
          <p style={{ color: "#3A3A49", fontWeight: "600", width: 50 }}>
            {value}
          </p>
        ),
      },
      {
        Header: "Blocked on",
        accessor: "blocked_on",
        Cell: ({ value }) => (
          <p style={{ color: "#3A3A49", fontWeight: "600", width: 50 }}>
            {value}
          </p>
        ),
      },
      {
        Header: "Blocked by",
        accessor: "blocked_by",
        Cell: ({ value }) => {
          console.log("value", value);

          return (
            <p style={{ color: "#3A3A49", fontWeight: "600", width: 50 }}>
              {value}
            </p>
          );
        },
      },
      {
        Header: "Blocked Duration",
        accessor: "blocked_duration",
        Cell: ({ value, row }) => {
          const formatDate = (dateString) => {
            const [year, month, day] = dateString?.split("-");
            return `${day}/${month}/${year}`;
          };

          return (
            <p>
              {value[0] && formatDate(value[0])},{" "}
              {value[1] && formatDate(value[1])}&nbsp;
              {value.length > 2 && (
                <img
                  src={view_icon}
                  alt=""
                  className="edit-btn"
                  style={{ width: 20, height: 20 }}
                  onClick={() => openPopup({ row: row.original, type: "edit" })}
                />
              )}
            </p>
          );
        },
      },
    ];
    let action = {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => (
        <button
          onClick={() => openPopup({ row: row.original, type: "edit" })}
          className="unblock__button"
          style={{ color: "#fff", fontWeight: "600", fontSize: 12 }}
        >
          Unblock
        </button>
      ),
    };
    return checkPermission("CAN-EDIT-PROPERTIES") ? [...d, action] : d;
  }, [page]);
  console.log("isOwners_isBlockDate", isBlockDate);

  return (
    <div>
      <Topbar header="Block" subHead="Properties" />
      <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
        Total: {owners.length}
      </h2>
      <div className="d-flex ac-je mt-3 gap-4 flex-wrap">
        <DateRange1
          setFromDate={(date) => handleChangeFilter("from_date", date)}
          holidays={isBlockDate}
          hideToRange={true}
          // setToDate={(date) => handleChangeFilter("to_date", date)}
        />
        <div className="d-flex ac-jc">
          <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
            State :{" "}
          </label>
          <Select
            className="location-search"
            options={locationList.states}
            value={optionsList.state}
            onChange={handleStateSelect}
            placeholder="State"
            isClearable
          />
        </div>
        <div className="d-flex ac-jc">
          <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
            City :{" "}
          </label>
          <Select
            className="location-search"
            options={locationList.cities}
            value={optionsList.city}
            onChange={handleCitySelect}
            placeholder="City"
            isClearable
          />
        </div>
        <div className="search-input">
          <input
            type="text"
            placeholder="Search Here"
            style={{ border: "none", width: "150px" }}
            onChange={(e) => handleChangeFilter("search", e.target.value)}
            value={selectedFilter.search}
          />
          <img src={Search_icon} className="search" />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />

      {popup && selectedRow && (
        <div className="img-popup-design2">
          <div className="img-popup2">
            <div className="d-flex ac-jb mx-4 mt-4">
              <p className="primary f3 ms-xl-12 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24">
                Resort
              </p>
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => setPopup(false)}
              />
            </div>
            <div style={{ height: "50%", overflow: "hidden" }}>
              <div style={{ height: "390px", overflow: "scroll" }}>
                {(selectedRow.blocked_duration || []).map((ele, ind) => {
                  const formatDate = (dateString) => {
                    const [year, month, day] = dateString?.split("-");
                    return `${day}/${month}/${year}`;
                  };

                  return (
                    <div className="d-flex ac-jb resort-contain" key={ind}>
                      <p className="f2 fs-xs-10 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
                        {ele && formatDate(ele && ele)}
                      </p>
                      {type === "edit" && (
                        <img
                          src={activeStates[ind] ? resort_act : resort_inact}
                          alt="resort"
                          style={{ cursor: "pointer" }}
                          className="resort-icon"
                          onClick={() => toggleActive(ind)}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="popup-button">
              <button
                disabled={type !== "edit"}
                onClick={handleUnblock}
                className="unblock_button f3 p-2 fs-xs-10 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20"
              >
                Unblock
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Properties_block;
